import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CustomPipesModule } from "@app/_pipes/custom-pipes.module";
import { ComeAndGoRulebreakFixDialogModule } from "@app/components/come-and-go-rulebreak-dialog/come-and-go-rulebreak-dialog.module";
import { ComeAndGoSuggestionDialogModule } from "@app/components/come-and-go-suggestion-dialog/come-and-go-suggestion-dialog.module";
import { MaterialModule } from "@app/material.module";
import { TagPickerDialogModule } from "@app/shared/dialogs/tag-picker-dialog/tag-picker-dialog.module";
import { TimeInputModule } from "@app/shared/time-input/time-input.module";
import { UserAvatarModule } from "@app/shared/user-avatar/user-avatar.module";
import { TranslateModule } from "@ngx-translate/core";
import { ComeAndGoMultiUpdateDialogModule } from "../come-and-go-multi-update-dialog/come-and-go-update-dialog.module";
import { UserSinglePickerDialogModule } from "../user-single-picker-dialog/user-single-picker-dialog.module";
import { ComeAndGoCreateDialogComponent } from "./come-and-go-create-dialog.component";

@NgModule({
	declarations: [ComeAndGoCreateDialogComponent],
	imports: [
		CommonModule,
		MaterialModule,
		FormsModule,
		ReactiveFormsModule,
		TranslateModule,
		UserAvatarModule,
		UserSinglePickerDialogModule,
		TimeInputModule,
		TagPickerDialogModule,
		ComeAndGoMultiUpdateDialogModule,
		ComeAndGoRulebreakFixDialogModule,
		ComeAndGoSuggestionDialogModule,
		CustomPipesModule,
	],
})
export class ComeAndGoCreateDialogModule {}
